/**
 * resourceSecurityLogConfiguration模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceSecurityLogConfiguration = {
  	//增加
  	configuration(params) {
    	return $http.post(`${global.API_URL}/sme/resourceSecurityLogConfiguration/configuration`,params);
  	},
    //查询
    query(params) {
      return $http.post(`${global.API_URL}/sme/resourceSecurityLogConfiguration/query`,params);
    }
   	
}

export default resourceSecurityLogConfiguration;



// WEBPACK FOOTER //
// ./src/api/resourceSecurityLogConfiguration.js